export default {
  // 订阅列表
  subscriptionList: {
    title: 'My Subscription',
    subscriptionDetail: 'Subscription Detail',
    changeAddress: 'Change Address',
    productType: 'Product Type',
    subscriptionStatusList: [
      {
        value: '',
        label: 'All',
      },
    ],
    noOrders: 'No orders under this category. Browse more courses provided by Think Academy.',
    moreCourses: 'Browse More Courses',
    noSubscriptionText: 'You currently do not have any auto-renewal subscriptions',
    unSubscribeTipsTitle: 'Please contact your learning center to cancel the subscription',
    unSubscribeTipsContent: 'After cancelling the subscription, there will be no charges for the next month. Existing orders will not affect ongoing classes.',
    autoRenewal: 'Auto Renewal',
    openRecords: 'Activation Records',
    learnPlayTag: 'Math',
    every: 'Every',
    timeLimit: 'Period',
    month: 'months',
    phase: 'Phase',
    stage: 'Stage {num}',
    deductionDate: 'Deduction Date',
    deductionAmount: 'Deduction Amount',
    status: 'Status',
    statusText: {
      1: 'To be paid',
      2: 'Paid',
      3: 'Payment Failed',
    },
    unsubscribe: 'Unsubscribe',
    weekMap: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    weekMapFull: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    weekDayList: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    monthsList: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    monthsListFull: [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December',
    ],
    curriculumSchedule: 'Curriculum schedule',
    today: 'today',
    classBegun: 'started',
    unClassBegun: 'not started',
    noClasses: 'No classes today',
    activedTip: 'Click the check box to activated',
  },
  subscriptionCard: {
    pay: 'Pay',
    unsuceess: 'Unsuceessful Deduction',
    viewOrder: 'View Order',
    start: 'Start Time',
    end: 'End Time',
    nextPay: 'Estimated Next Payment',
    expire: 'Expiration Time',
    expireDate: 'Expiry Date',
    orderTime: 'Order Time',
    statusText: {
      1: 'To be paid',
      2: 'Active',
      3: 'Active',
      4: 'Cancelled',
    },
    paymentMethod: 'Payment Method',
    pos: '联机POS分期支付',
    card: 'Card',
    MakeupPayment: 'Repay',
  },
  subscriptionDetail: {
    cancel: 'Cancel subscription',
    cancelReasons: 'Cancel Reasons',
    title: 'Subscription Detail',
  },
  // 支付失败结果页提示文案
  toBePaidResult: {
    title: '付款重要提示',
    content: '如果您已经被扣款，但订单并不是“已支付”状态，可能是因为我们还未收到银行的扣款通知，请您稍后查看。如果有任何问题，请联系我们客服：',
    confirm: '知道了',
  },
  childFilter: {
    child: 'Child',
    type: 'Type',
    kids: 'Kids',
    save: 'Save',
  },
  address: {
    noAddress: 'You haven\'t added an address yet',
  },
  coupon: {
    title: 'My Coupons',
    detail: 'Coupon Details',
    recommendClass: 'Recommended Class',
    testResult: 'Understanding the test result',
    on: 'On {feeName}',
    over: 'Over {symbol}{price}',
    off: '%Off',
    offThousand: '‰Off',
    noAvailable: 'No available course can be applied to the chosen coupon.',
    redeemFailedTips: 'Promo code not found. Please try again',
    redeemFailedCodeText: {
      4003: '很抱歉，当前活动已结束',
      7003: '很抱歉，此活动仅限新学员参与',
      7004: '您已参与过当前活动',
      7005: '您已参与过当前活动',
    },
  },
  courses: {
    title: 'Courses',
    availableClass: 'Available Classes',
    noCoursesTip: 'No courses under this category. Browse more courses provided by Think Academy.',
    moreCourses: 'Browse More Courses',
  },
  tips: {
    editSuccess: 'Student edited successfully',
    copyFiled: 'Copied Failed',
    copySuccess: 'Copied Successfully',
    success: 'Successfully',
    redeemSuccess: 'Redeem Successful',
    addSuccess: 'Student added successfully',
    login: 'Please Login again',
    loginTips: 'Your login session has expired. Please login again to continue',
    cancel: 'Cancel',
    loginAgain: 'Login Again',
    invalid: 'The input is required',
    removeWish: 'Removed from the wish list',
    loading: 'Loading...',
    deleteSuccess: 'Delete Successful',
    addSuccessful: 'Add Successful',
    updateSuccess: 'Update Successful',
    updateFailed: 'Update failed. Same with the previous address.',
    viewCourses: 'View Courses',
    emptyTips: 'Available courses coming soon! View currently available courses provided by Think Academy',
    before: 'Before',
    after: 'After',
  },
  coursesCardTag: {
    new: 'New',
    popular: 'Popular',
    full: 'Full',
    current: 'Current',
    completed: 'Completed',
    refunded: 'Refunded',
    playBack: 'Playback Only',
  },
  getNotifiedConfig: {
    title: 'Can\'t Find an Appropriate Course for Your Child?',
    description: 'That\'s ok! While you take some time to think, leave your email with us to receive admissions support for grammar and independent school entry, links to 11+ webinars and more practice materials.',
    form: {
      grade: 'Child\'s Year group',
      firstName: 'Child\'s first name',
      lastName: 'Last name',
      email: 'Your email',
      platform: 'How did you find out about us?',
    },
    notice: 'Sign up for our mailing list to receive the latest news, promotions and updates! ',
    errorNotice: 'Submission failed. Please try again later.',
    emailError: 'The Email address seems invalid.',
    phoneError: 'The phone number seems invalid.',
    submit: 'Submit',
    success: 'Thank you for your interest in Think Academy!',
  },
  // Cookies声明
  cookiesStatement: {
    description: 'We use cookies to provide you with better services. By clicking any link on this page, your consent has been given.',
  },
  // cookies policy
  cookiesAccept: {
    title: 'Our Use of Cookies',
    description: `<p>We use Cookies to personalise your user experience on our website.</p>
    <p>For more information please see our <a href="/cookies-policy" target="_blank">Cookie Policy</a></p>`,
    accept: 'Accept',
    reject: 'Reject',
  },
  unpaidCourses: {
    tips1: `
      <p class="dotted-para" style="margin-left: 10px; margin-bottom: 10px;">Due to high demand for classes, 
      there is a deadline for switching class. Please select the class you want between: <span style="color: #3e6eff;">{startTime} - {endTime}</span></p>`,
    tips2: `
      <p class="dotted-para" style="margin-left: 10px; margin-bottom: 10px;">Due to high demand for classes, 
      there is a deadline for switching class. Please select the class you want after: <span style="color: #3e6eff;">{startTime}</span></p>`,
    tips3: `
      <p class="dotted-para" style="margin-left: 10px; margin-bottom: 10px;">Due to high demand for classes, 
      there is a deadline for switching class. Please select the class you want before the deadline: <span style="color: #3e6eff;">{endTime}</span></p>`,
  },
  triageDesk: {
    selectChildForEvaluation: '请选择需要进行评估的孩子：',
    evaluateAnotherChild: '为另一个孩子进行评估',
    previousStep: '上一步',
    nextStep: '下一步',
    provideContactInfoForResults: '请提供您的联系方式以获取评估结果：',
    childName: '您孩子的名字',
    firstName: '名字',
    lastName: '姓氏',
    providePhoneNumber: '请提供您的电话号码',
    phoneNumber: '电话号码',
    provideEmailAddress: '请提供您的电子邮件地址',
    emailAddress: '电子邮件地址',
    enterValidPhoneNumber: '请输入有效的电话号码',
    enterValidEmailAddress: '请输入有效的电子邮件地址',
    provideContactInfoForMaterials: '请提供您的联系方式以获取学习资料：',
    submit: '提交',
    submissionSuccessDownload: '提交成功！点击下载您的学习资料！',
    downloadingAutoClickButton: '自动下载中... 若没有开始下载，请点击下方按钮进行下载。',
    download: '下载',
    selectEvaluationMethod: '请选择您偏好的评估方式：',
    onlineEvaluation: '在线评估',
    completeOnlineAssessment: '完成在线评估试题，我们的专业老师会联系您，为您分析评估结果。',
    evaluationViaZoom: '通过Zoom进行评估',
    scheduleProfessionalTeacher: '预约我们的专业老师，为您的孩子进行一对一评估。',
    evaluateInLearningCenter: '在学习中心进行评估',
    scheduleVisitCupertino: '预约到访{campus}，我们的专业老师将为您的孩子进行一对一评估。',
    evaluationScheduledSuccess: '您的评估已预约成功！',
    scheduleSentEmail: '您的日程将会发送到您的电子邮箱：{emailAddress}',
    scheduleInformation: '日程信息',
    childNameLabel: '孩子姓名：',
    gradeLabel: '年级：',
    dateLabel: '日期：',
    timeLabel: '时间：',
    yourPhoneNumberLabel: '您的电话号码：',
    yourEmailAddressLabel: '您的电子邮件地址：',
    zoomLinkLabel: 'Zoom链接：',
    locationLabel: '地点：',
    addressLabel: '地址：',
    contactUsLabel: '联系我们：',
    workingHoursLabel: '工作时间：',
    scheduleAssessment: '请预约您的评估：',
    noSuitableTimeContactUs: [
      '没有合适的时间？',
      '重新选择评估方式',
      '或直接联系我们：拨打电话<span class="color">{phoneNumber}</span>，或发送电子邮件至<span class="color">{emailAddress}</span>。',
    ],
    selectPreferredTime: '请选择您偏好的时间：',
    contactUsInfo: '没有合适的时间？请拨打 <span class="color">{phoneNumber}</span> 或发送邮件至 <span class="color">{emailAddress}</span>。',
    dateHeader: '日期',
    timeHeader: '时间',
    slotsHeader: '名额',
    fiveLeft: '剩余{num}个',
    fullClass: '已满班',
    lessons: '课次',
    signUp: '报名',
    switchToCupertinoQuestions: '正在切换至{campus}，我们将重新询问您几个问题。',
    confirm: '确认',
    cancel: '取消',
    maxStudentAccountsLimit: '最多只能添加6个学员账号，请重新选择现有学员。',
    loading: '加载中...',
    loadingFailed: '加载失败，请稍后重试。',
    retry: '重试',
  },
}
